var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import { Headers, Status } from "./TableHeaders";
import { TableFilterSort } from "./Table.filters.sorts";
import { Rows } from "./Rows";
import { Search } from "./Search";

import { utils, Filter, ContextualMenu, ContextualMenuClient } from "zebulon-controls";
import { computeData, computeAudit } from "./utils/compute.data";
import { computeMetaPositions } from "./utils/compute.meta";

// import { utils } from "zebulon-controls";
export var Table = function (_TableFilterSort) {
  _inherits(Table, _TableFilterSort);

  function Table(props) {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

    _initialiseProps.call(_this);

    var filteredData = _this.filters(props.data, props.filters);
    var status = props.status;
    if (props.meta.serverPagination && status.loaded) {
      status = { loaded: false, loading: true };
      props.data({ startIndex: 0 }).then(function (filteredData) {
        computeData(filteredData.page, props.meta, 0);
        if (props.onGetPage) {
          props.onGetPage(filteredData);
        }
        _this.setState({
          filteredData: filteredData,
          filteredDataLength: filteredData.filteredDataLength,
          status: { loaded: true, loading: false }
        });
      });
    }
    //  else if (this.props.callbackForeignKey && filteredData.length < 2) {
    //   this.props.callbackForeignKey(
    //     filteredData.length ? filteredData.length[0] : false
    //   );
    // } // a voir serverPagination
    _this.sorts(filteredData, props.meta.properties);
    var columns = props.meta && props.meta.visibleIndexes ? props.meta.visibleIndexes[0] : 0;
    _this.state = {
      data: props.data,
      filteredData: filteredData,
      params: props.params,
      meta: props.meta,
      filters: props.filters || {},
      status: status,
      updatedRows: props.updatedRows,
      scroll: {
        rows: {
          index: 0,
          direction: 1,
          startIndex: 0,
          shift: 0,
          position: 0
        },
        columns: {
          index: 0,
          direction: 1,
          startIndex: 0,
          shift: 0,
          position: 0
        }
      },
      selectedRange: {
        start: { rows: 0, columns: columns },
        end: { rows: 0, columns: columns }
      },
      detail: {},
      text: {},
      checkAll: false,
      search: false,
      dataStrings: {}
    };
    // this.state.selectedRangeAudit = this.state.selectedRange;
    // this.state.scrollAudit = this.state.scroll;
    _this.rowHeight = _this.props.rowHeight;
    _this.range = { start: {}, end: {} };
    _this.onTableEnter();
    if (status.loaded) {
      _this.bLoaded = true;
    }
    if (_this.props.contextualMenu) {
      if (typeof _this.props.contextualMenu === "function") {
        _this.customContextualMenu = _this.props.contextualMenu(_this.state, props);
      } else {
        _this.customContextualMenu = _this.props.contextualMenu;
      }
    }
    // this.filtersOut = props.filters;
    return _this;
  }
  // componentDidMount() {
  //   this.selectRange(this.state.selectedRange, undefined, undefined, "enter");
  // }


  _createClass(Table, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data || nextProps.meta !== this.props.meta || nextProps.status !== this.props.status || nextProps.updatedRows !== this.props.updatedRows) {
        // const filteredData = this.filters(nextProps.data, nextProps.filters);
        var filteredData = [];
        var status = nextProps.status;
        // if (nextProps.meta.serverPagination) {
        //   if (status.loaded && !this.props.status.loaded) {
        //     status = { loaded: false, loading: true };
        //     nextProps.data({ startIndex: 0 }).then(filteredData => {
        //       computeData(filteredData.page, nextProps.meta, 0);
        //       if (nextProps.onGetPage) {
        //         nextProps.onGetPage(filteredData);
        //       }
        //       this.setState({
        //         filteredData,
        //         filteredDataLength: filteredData.filteredDataLength,
        //         status: { loaded: true, loading: false }
        //       });
        //     });
        //   }
        // } else {
        filteredData = this.filters(nextProps.data, this.state.filters);
        this.sorts(filteredData, nextProps.meta.properties);
        // }

        this.setState({
          data: nextProps.data || [],
          filteredData: filteredData,
          filteredDataLength: filteredData.length,
          meta: nextProps.meta,
          status: status,
          updatedRows: nextProps.updatedRows,
          // selectedRange: { start: {}, end: {} },
          scroll: {
            rows: {
              index: 0,
              direction: 1,
              startIndex: 0,
              shift: 0,
              position: 0
            },
            columns: {
              index: 0,
              direction: 1,
              startIndex: 0,
              shift: 0,
              position: 0
            }
          }
        });
        if (status.loaded && this.bLoaded === undefined) {
          this.bLoaded = true;
        }
        if (status.loaded && this.props.callbackForeignKey && filteredData.length < 2) {
          this.props.callbackForeignKey(filteredData.length === 1, filteredData[0]);
          return null;
        }
      }
      this.rowHeight = nextProps.rowHeight;
      if (nextProps.visible && !this.props.visible) this.onTableEnter();
      // else if (!nextProps.visible && this.props.visible) {
      //   this.onTableQuit();
      // }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !nextProps.modal;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      return this.onTableClose();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onLoad();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onLoad();
      this.changingFilter = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          height = _props.height,
          width = _props.width,
          isModal = _props.isModal,
          visible = _props.visible,
          params = _props.params;
      var _state = this.state,
          status = _state.status,
          meta = _state.meta,
          selectedRange = _state.selectedRange,
          updatedRows = _state.updatedRows,
          data = _state.data,
          auditedRow = _state.auditedRow,
          audits = _state.audits,
          scroll = _state.scroll,
          filteredData = void 0,
          filteredDataLength = void 0;
      var selectRange = this.selectRange,
          onScroll = this.onScroll;

      var headersLength = 1 + !meta.table.noFilter * (1 + (meta.properties.findIndex(function (column) {
        return column.filterType === "between" && !column.hidden;
      }) !== -1));
      // -----------------------------
      // audit
      // -----------------------------
      // console.log("render", scroll, selectedRange);
      var auditStatus = void 0;
      if (auditedRow) {
        // selectRange = undefined;
        headersLength = 2;
        auditStatus = updatedRows[auditedRow.index_] || {};
        meta = Object.assign({}, meta, {
          table: Object.assign({}, meta.table, { editable: false }),
          properties: [{
            id: "user_",
            caption: "User",
            width: 80
          }, {
            id: "time_",
            caption: "Time",
            dataType: "date",
            format: "time",
            formatFunction: function formatFunction(_ref) {
              var value = _ref.value;
              return utils.formatValue(value, "dd/mm/yyyy hh:mi:ss");
            },
            width: 130
          }, {
            id: "status_",
            caption: "Status",
            dataType: "string",
            width: 70
          }].concat(_toConsumableArray(meta.properties))
        });
        computeMetaPositions(meta, this.props.zoom); // A voir zoom
        meta.lockedIndex = 2;
        meta.lockedWidth = 280 * this.props.zoom;
        var row = auditStatus.row || auditStatus.rowUpdated || auditedRow;
        var rowUpdated = auditStatus.updated_ && !auditStatus.new_ ? auditStatus.rowUpdated : undefined;
        filteredData = computeAudit(rowUpdated, row, meta, audits);
        auditedRow = filteredData[0];
        filteredData.splice(0, 1);
        filteredDataLength = filteredData.length;
      } else {
        filteredData = this.state.filteredData;
        filteredDataLength = this.state.filteredData.length;
      }

      var actions = auditedRow || isModal || meta.properties.length === 0 ? [] : meta.table.actions.filter(function (action) {
        return !action.hidden;
      }) || [];
      if (!visible) {
        return null;
      } else if (status.loading || status.loadingConfig) {
        return React.createElement(
          "div",
          null,
          "Loading data..."
        );
      } else if (status.error) {
        if (status.error.message === "No rows retrieved") {
          return React.createElement(
            "div",
            { style: { width: "max-content" } },
            "No rows retrieved"
          );
        } else {
          return React.createElement(
            "div",
            { style: { color: "red", width: "max-content" } },
            React.createElement(
              "p",
              null,
              status.error.type
            ),
            React.createElement(
              "p",
              null,
              status.error.message
            )
          );
        }
      } else if (data.length === 0 && meta.properties.length === 0) {
        return null;
      }
      var noUpdate = !this.isInPage(scroll.rows) || this.noUpdate;
      this.noUpdate = false;
      // -----------------------------------
      // Filter check list
      // -----------------------------------
      var _state2 = this.state,
          openedFilter = _state2.openedFilter,
          filters = _state2.filters;

      this.openedFilter = null;
      if (openedFilter !== undefined) {
        var _filters$openedFilter = filters[openedFilter],
            _top = _filters$openedFilter.top,
            _left = _filters$openedFilter.left,
            items = _filters$openedFilter.items,
            _v = _filters$openedFilter.v,
            caption = _filters$openedFilter.caption,
            computedWidth = _filters$openedFilter.computedWidth;

        this.filter = React.createElement(Filter, {
          items: items,
          title: caption,
          filter: _v,
          style: {
            position: "absolute",
            border: "solid 0.1em rgba(0, 0, 0, 0.5)",
            backgroundColor: "white",
            fontFamily: "inherit",
            top: _top,
            left: _left,
            width: Math.max(computedWidth * 1.2, 150),
            zIndex: 3,
            opacity: 1
          },
          onOk: this.onChangeFilterValues,
          ref: function ref(_ref2) {
            return _this2.openedFilter = _ref2;
          }
        });
      } else {
        this.filter = undefined;
      }
      // ------------------------
      // text area
      // ------------------------
      var _state$text = this.state.text,
          top = _state$text.top,
          left = _state$text.left,
          v = _state$text.v,
          editable = _state$text.editable,
          label = _state$text.label;

      if (top !== undefined) {
        this.text = React.createElement(
          "div",
          {
            style: {
              position: "absolute",
              border: "solid 0.1em rgba(0, 0, 0, 0.5)",
              backgroundColor: "white",
              top: top + (headersLength - 2) * this.rowHeight,
              left: left,
              zIndex: 3,
              opacity: 1
            }
          },
          React.createElement(
            "div",
            null,
            label,
            " "
          ),
          React.createElement("textarea", {
            rows: "10",
            cols: "80",
            id: "textarea",
            tabIndex: 0,
            style: { top: top, left: left, font: "inherit" },
            disabled: !editable,
            autoFocus: true,
            value: v || "",
            onChange: this.handleTextChange
            // ref={ref => (this.focused = ref)}
          })
        );
      } else {
        this.text = undefined;
      }
      // ------------------------
      // Detail
      // ------------------------
      var detail = this.state.detail.content;
      if (detail) {
        var _row = selectedRange.end.rows !== undefined ? this.getRow(selectedRange.end.rows) : {};
        var _status = updatedRows[_row.index_];
        //       top: (3 + rowIndex) * this.rowHeight + scroll.rows.shift,
        // left:
        //   column.position + this.rowHeight - scroll.columns.position
        detail = this.getDetail({
          Detail: detail,
          row: _row,
          data: data,
          meta: meta.properties,
          status: _status,
          params: params,
          top: (2 + headersLength + selectedRange.end.rows - scroll.rows.startIndex) * this.rowHeight + scroll.rows.shift,
          onChange: meta.row.onChange,
          onClose: this.closeOpenedWindows
        });
      }
      // ------------------------
      // errors
      // ------------------------
      var toolTip = this.state.toolTip || null;
      if (toolTip) {
        var content = React.createElement(
          "ul",
          { style: { paddingLeft: 20, maxWidth: 300 } },
          toolTip.content.map(function (error, index) {
            return React.createElement(
              "li",
              { key: index },
              error.error
            );
          })
        );
        toolTip = React.createElement(
          "div",
          {
            key: "tool-tip",
            className: "zebulon-tool-tip",
            style: { top: toolTip.top, left: toolTip.left, position: "absolute" }
          },
          content
        );
      }
      this.rowsHeight = height - (meta.table.caption ? 30 : 0) - headersLength * this.rowHeight - (actions.length ? 30 : 0);
      // ------------------------
      // search
      // ------------------------
      var search = null;

      if (this.state.search) {
        var _state3 = this.state,
            _filteredData = _state3.filteredData,
            _meta = _state3.meta,
            dataStrings = _state3.dataStrings,
            _scroll = _state3.scroll;

        var _content = React.createElement(Search, {
          filteredData: _filteredData,
          meta: _meta,
          dataStrings: dataStrings,
          scroll: _scroll,
          rowStartIndex: _scroll.rows.startIndex + _scroll.rows.shift === 0 ? 0 : 1,
          rowStopIndex: Math.min(_scroll.rows.startIndex + Math.floor(this.rowsHeight / this.rowHeight) - (_scroll.rows.shift === 0 ? 1 : 0), _filteredData.length - 1),
          onClose: function onClose() {
            return _this2.setState({ search: false });
          }
          // selectRange={this.selectRange_}
          , selectedCell: this.state.selectedRange.end,
          scrollTo: this.scrollTo
        });
        search = React.createElement(
          "div",
          {
            key: "tool-tip",
            className: "zebulon-tool-tip",
            style: { top: 0, left: 0, position: "absolute" }
          },
          _content
        );
      }

      // ----------------------------------
      // Status bar
      // ----------------------------------
      var statusBar = void 0;
      if (meta.table.noStatus) {
        statusBar = null;
      } else {
        statusBar = React.createElement(Status, {
          key: "statusBar",
          data: filteredData,
          status: status,
          dataLength: filteredDataLength,
          height: this.rowsHeight,
          rowHeight: this.rowHeight,
          scroll: scroll.rows,
          updatedRows: updatedRows,
          selectRange: this.selectRange,
          selectedIndex: selectedRange.end.rows,
          meta: meta,
          handleErrors: this.handleErrors,
          noUpdate: noUpdate,
          component: this.props.id,
          checkable: meta.table.checkable,
          onDoubleClick: this.onDoubleClick,
          draggable: meta.table.statusDraggable,
          isAudit: auditedRow ? true : false
        });
      }
      // -----------------------------
      //   action buttons
      // -----------------------------
      actions = actions.map(function (action, index) {
        if (!_this2.doubleClickAction && action.doubleClick) {
          _this2.doubleClickAction = action;
        }
        var enable = action.enable || false;
        if (status.loadingPage) {
          enable = false;
        } else if (action.enableFunction) {
          var _row2 = selectedRange.end.rows !== undefined ? _this2.getRow(selectedRange.end.rows) : { index_: undefined };
          var _status2 = updatedRows[_row2.index_];
          enable = action.enableFunction({ row: _row2, status: _status2 });
        }
        action.statusEnable = action.enable && enable;
        var lastColumn = meta.properties[meta.properties.length - 1];
        var actionsWidth = Math.min(lastColumn.position + lastColumn.computedWidth + _this2.rowHeight * (statusBar !== null), width - 4 * actions.length) / actions.length || 0;
        var style = {
          width: actionsWidth,
          minWidth: 50,
          margin: 2,
          marginTop: 6
          // backgroundColor: "lightgrey"
        };
        var className = enable ? "zebulon-action-button" : "zebulon-action-button-disabled";
        if (action.jsxFunction) {
          return action.jsxFunction({
            disabled: !enable,
            className: className,
            index: index,
            style: style,
            onClick: function onClick(e) {
              return _this2.handleAction(action, e);
            }
          });
        }
        return React.createElement(
          "button",
          {
            key: index,
            disabled: !enable,
            className: className,
            style: style,
            onClick: function onClick(e) {
              return _this2.handleAction(action, e);
            }
          },
          action.caption
        );
      });
      var style = {};
      var locked = !utils.isNullOrUndefined(meta.lockedIndex) && meta.lockedWidth;
      if (locked) {
        style = {
          borderLeft: "solid 0.05em rgba(0, 0, 0, .5)",
          boxSizing: "border-box"
        };
      }
      // console.log("table", this.hasFocus, this.changingFilter);
      var rows = React.createElement(Rows, {
        key: "rows",
        meta: meta,
        data: filteredData,
        status: status,
        dataLength: filteredDataLength,
        height: this.rowsHeight,
        width: width - this.rowHeight * (statusBar !== null) - (meta.lockedWidth || 0),
        rowHeight: this.rowHeight,
        scroll: scroll,
        onScroll: onScroll,
        selectedRange: selectedRange,
        selectRange: selectRange,
        onChange: this.onChange,
        onFocus: function onFocus(e, row, column) {
          return _this2.closeOpenedWindows(true, column);
        },
        hasFocus: this.hasFocus,
        updatedRows: updatedRows,
        params: params,
        navigationKeyHandler: this.props.navigationKeyHandler,
        ref: function ref(_ref3) {
          return _this2.rows = _ref3;
        },
        noUpdate: noUpdate,
        style: style,
        onDoubleClick: this.onDoubleClick,
        component: this.props.id
      });
      var lockedColumns = null;
      if (locked) {
        lockedColumns = React.createElement(Rows, {
          key: "lockedColumns",
          meta: meta,
          data: filteredData,
          status: status,
          dataLength: filteredDataLength,
          height: this.rowsHeight,
          width: meta.lockedWidth,
          rowHeight: this.rowHeight,
          scroll: scroll,
          onScroll: onScroll,
          selectedRange: selectedRange,
          selectRange: selectRange,
          onChange: this.onChange,
          onFocus: function onFocus(e, row, column) {
            return _this2.closeOpenedWindows(true, column);
          },
          hasFocus: this.hasFocus,
          updatedRows: updatedRows,
          params: params,
          noUpdate: noUpdate,
          noVerticalScrollbar: true,
          onDoubleClick: this.onDoubleClick,
          locked: locked,
          component: this.props.id
        });
      }

      var headers = React.createElement(Headers, {
        onSort: this.onSort,
        meta: meta,
        data: data,
        height: this.rowHeight * headersLength,
        width: width - this.rowHeight * (statusBar !== null) - (meta.lockedWidth || 0),
        scroll: scroll.columns,
        headersLength: headersLength,
        onMetaChange: this.onMetaChange,
        openFilter: this.openFilter,
        onChange: this.onChangeFilter,
        style: style,
        component: this.props.id,
        auditedRow: auditedRow,
        auditStatus: auditStatus,
        isActive: this.props.isActive,
        onActivation: this.props.onActivation,
        changingFilter: this.changingFilter
      });
      var lockedHeaders = null;
      if (!utils.isNullOrUndefined(meta.lockedIndex) && meta.lockedWidth) {
        lockedHeaders = React.createElement(Headers, {
          onSort: this.onSort,
          meta: meta,
          data: auditedRow ? data : null,
          height: this.rowHeight * headersLength,
          width: meta.lockedWidth,
          scroll: scroll.columns,
          headersLength: headersLength,
          onMetaChange: this.onMetaChange,
          openFilter: this.openFilter,
          onChange: this.onChangeFilter,
          locked: true,
          component: this.props.id,
          auditedRow: auditedRow,
          auditStatus: auditStatus,
          isActive: this.props.isActive,
          onActivation: this.props.onActivation,
          changingFilter: this.changingFilter
        });
      }
      var statusBarHeader = [];
      if (statusBar !== null) {
        for (var i = 0; i < headersLength; i++) {
          var checkbox = null;
          if (i === 0 && meta.table.checkable === true) {
            checkbox = React.createElement("input", {
              type: "checkbox",
              checked: this.state.checkAll,
              onChange: this.onCheckAll
            });
          }
          statusBarHeader.push(React.createElement(
            "div",
            {
              key: "status-" + i,
              className: "zebulon-table-corner",
              style: {
                width: this.rowHeight,
                height: this.rowHeight,
                top: i * this.rowHeight
                // border: "0.02em solid rgba(0, 0, 0, 0.3)",
                // padding: 4
              }
            },
            checkbox
          ));
        }
        statusBarHeader = React.createElement(
          ContextualMenuClient,
          {
            key: "header-status",
            id: "header-status",
            menu: "top-left-corner-menu",
            component: this.props.id
          },
          statusBarHeader
        );
      } else {
        statusBarHeader = null;
      }
      // statusBar !== null ? <div style={{ display: "block" }}>{1}</div> : null;
      // {filterHeaders}
      var title = null;
      if (meta.table.caption) {
        title = React.createElement(
          "div",
          {
            key: "title",
            className: "zebulon-table-title",
            style: {
              fontWeight: "bold",
              textAlign: "center",
              padding: 4,
              border: "solid 0.03em rgba(0,0,0,.2)",
              height: 30,
              width: width,
              boxSizing: "border-box"
            }
          },
          meta.table.caption
        );
      }
      // const className = "zebulon-table";
      return React.createElement(
        "div",
        {
          id: this.props.id,
          style: Object.assign({
            width: "max-content",
            height: "fit-content"
          }, this.props.style)
        },
        React.createElement(
          "div",
          null,
          React.createElement(ContextualMenu, {
            key: "table-menu",
            getMenu: this.getMenu,
            component: this.props.id,
            id: "table-menu",
            ref: function ref(_ref4) {
              return _this2.contextualMenu = _ref4;
            }
          }),
          detail,
          this.filter,
          this.text,
          toolTip,
          search,
          title,
          React.createElement(
            "div",
            {
              style: {
                // display: "-webkit-box"
                display: "flex"
              }
            },
            statusBarHeader,
            lockedHeaders,
            headers
          ),
          React.createElement(
            "div",
            { style: { display: "flex" } },
            statusBar,
            lockedColumns,
            rows
          )
        ),
        React.createElement(
          "div",
          { style: { height: actions.length ? 30 : 0, display: "flex" } },
          actions
        ),
        " "
      );
    }
  }]);

  return Table;
}(TableFilterSort);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onLoad = function () {
    if (_this3.bLoaded && _this3.state.filteredData.length) {
      var columns = (_this3.state.meta.visibleIndexes || [0])[0];
      _this3.selectRange({
        start: { rows: 0, columns: columns },
        end: { rows: 0, columns: columns }
      }, undefined, _this3.state.filteredData[0], "enter", true);
      _this3.hasFocus = true;
      _this3.bLoaded = null;
    }
  };

  this.onCheckAll = function () {
    var checked_ = !_this3.state.checkAll;

    _this3.state.filteredData.forEach(function (row) {
      return _this3.state.updatedRows[row.index_] = { checked_: checked_, errors: {} };
    });
    _this3.setState({ checkAll: checked_, updatedRows: _this3.state.updatedRows });
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-table/lib/Table.js
// module id = 342
// module chunks = 0